import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next'
import React from 'react'
import { Breadcrumbs } from '../components/Breadcrumbs'
import SvgBulb from '../components/icons/SvgBulb'
import { Intro } from '../components/Intro'
import { MissingContent } from '../components/MissingContent'
import { ModalContent, useIsInModal } from '../components/ModalManager'
import { Seo } from '../components/Seo'
import { VendorLayout } from '../components/VendorLayout'
import { Spacer } from '../components/Spacer'
import { usePageLink } from '../src/hooks/usePageLink'
import { useTranslate } from '../src/hooks/useTranslate'
import {
	VendorType,
	SpecialPageType,
	VendorExtendedFragment,
} from '../src/model/fragments'
import { getLocale, getPossibleLocales, Locale } from '../src/model/locale'
import { axiosGet } from '../src/utils/axiosWrapper'
import { WidthBound } from '../components/WidthBound'

export default function Place({
	place,
	possibleLocales,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
	// place.logo = null;
	const translate = useTranslate()
	const contactSalesRepresentativesLink = usePageLink(
		SpecialPageType.contactSalesRepresentatives,
	)
	const isInModal = useIsInModal()

	if (!place) {
		return <MissingContent />
	}

	const data = getLocale(place.locales, possibleLocales)
	if (!data) {
		return <MissingContent />
	}

	return <ModalContent>
		<Seo seo={data.seo} />
		{!isInModal && (
			<Breadcrumbs
				items={[
					...(contactSalesRepresentativesLink
						? [
								{
									label: translate(
										'contacts-navigation-contactSalesRepresentatives-label',
									),
									linkProps: contactSalesRepresentativesLink,
								},
							]
						: []),
					{
						label: data.title,
					},
				]}
			/>
		)}
		{isInModal && <Spacer initial={40} />}
		<WidthBound size="narrow">
			<Intro
				title={
					<>
						{data.title}
					</>
				}
				image={place.logo ?? undefined}
				smallImage
			/>
			
			<VendorLayout vendor={place} />
		</WidthBound>
		{!isInModal && <Spacer initial={100} />}
	</ModalContent>;
}

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
	const locale = ctx.query.locale as Locale
	const possibleLocales = getPossibleLocales(locale)
	const { getContactPlace: place } = await axiosGet('/vendors/detail', {locale: locale, vendorId: ctx.query.id}) as
	{
		getContactPlace: VendorExtendedFragment
	}
	
	return {
		props: { place, possibleLocales, modal: true, modalWidth: 'narrow' },
	}
}
